import { SignInLinkModel } from '../models/sign-in-link.model';

export const decodeSignInLink = (data: string): SignInLinkModel | null => {
  try {
    const params = new URLSearchParams(atob(data));
    const email = params.get('email');
    const code = params.get('code');
    if (!email || !code) return null;

    return { email, code, signInCompanyId: params.get('companyId') || null, redirectUrl: params.get('redirectUrl') || null };
  } catch (_) {
    return null;
  }
};
